import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { LanguageListContainer, LanguageListItem } from './styled'
import { useMyDispatch } from 'featureSliced/shared/hooks/useMyDispatch'
import { CommonSlice } from 'featureSliced/shared/store/reducers/CommonReducer'
import { languageList } from './languageList'
import { FC } from 'react'

type LanguageListProps = {
  closeThisModal: () => void
}

export const LanguageList: FC<LanguageListProps> = ({ closeThisModal }) => {
  const dispatch = useMyDispatch()
  const { setSelectedLanguage } = CommonSlice.actions
  const allowedLanguages = useMySelector(
    (state) => state.common.allowedLanguages
  )
  return (
    <LanguageListContainer>
      {allowedLanguages?.map((langCode) => {
        const language = languageList.find((l) => l.code === langCode)
        return (
          <LanguageListItem
            key={langCode}
            onClick={() => {
              dispatch(setSelectedLanguage(langCode))
              closeThisModal()
            }}
          >
            <p>{language?.icon}</p>
            <p>{language?.name}</p>
          </LanguageListItem>
        )
      })}
    </LanguageListContainer>
  )
}
